var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHappyCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 280,
    viewBox: "0 0 200 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "5871ba50-ebd7-494a-b0a8-8e0ee3e0bd24",
    cx: 119.32,
    cy: 72.13,
    r: 71.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#faee7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fbe571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fed659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "59d95db4-cc2a-4e3d-824e-95c26e51ef9b",
    cx: 85.27,
    cy: 76.72,
    r: 17.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a94b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#188db2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#14799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0d5a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073e5e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "17b4ace5-a28d-431f-a734-1518dcffba1d",
    cx: 153.55,
    cy: 77.23,
    r: 17.57,
    xlinkHref: "#59d95db4-cc2a-4e3d-824e-95c26e51ef9b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "be12dd70-9271-49cb-9b79-685037bbbb70",
    cx: 119.99,
    cy: 110.56,
    r: 11.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3837e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ee7c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "2f5b5800-3500-4f7a-831a-e1513659146e",
    cx: 119.32,
    cy: 91.51,
    r: 5.93,
    xlinkHref: "#be12dd70-9271-49cb-9b79-685037bbbb70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6d757a5f-8622-448c-89b5-b1781f93c869",
    x1: 126.16,
    y1: 129.89,
    x2: 135.8,
    y2: 141.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f8dd83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f4a881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ef547d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec297b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4380546f-d9f9-4b66-ac9d-fc695fd1d7c3",
    x1: 108.93,
    y1: 124.43,
    x2: 110.94,
    y2: 143.87,
    xlinkHref: "#6d757a5f-8622-448c-89b5-b1781f93c869"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconHappyCat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa67c6c6-1822-466b-b9d8-ef3fed0e8fef",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4ef582ab-2db0-4c9e-836a-924d3b9f643d",
    "data-name": "TAIL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.31,230.15c0,.35,0,.7,0,1a40.36,40.36,0,0,1-1.26,10.06c-.24,1-.54,2-.86,2.94q-.18.56-.39,1.11c-.06.18-.14.37-.2.55s-.13.32-.19.47-.18.46-.28.68-.14.32-.21.48-.2.47-.3.69c-.16.37-.33.72-.5,1.06-.34.69-.69,1.37-1.07,2-.19.33-.37.66-.57,1A45.24,45.24,0,0,1,53.68,273a45.89,45.89,0,0,1-6.8,1.07c-1.33.11-2.68.16-4,.16H22.24A30.1,30.1,0,0,1,18.4,274h-.16a19.93,19.93,0,0,1-7.59-1.46C4.37,270,0,264.37,0,257.87c0-8.33,7.19-15.18,16.4-16,.61-.06,1.22-.09,1.84-.09a20.3,20.3,0,0,1,5.73.82c.59,0,1.17.09,1.74.16,1,.19,1.95.35,2.95.49A46.33,46.33,0,0,0,69.18,228.5a44.59,44.59,0,0,0,4.29-5.57l.27-.42c.52-.79,1-1.62,1.47-2.45v0c.07-.11.12-.21.18-.31.5-.92,1-1.85,1.4-2.8,0-.1.09-.21.14-.32.13-.29.25-.57.37-.86q.66-1.55,1.2-3.15a45.18,45.18,0,0,0,2.29-12.48,62.89,62.89,0,0,0,6,12.53h0c0,.14.08.28.11.43a40.27,40.27,0,0,1,1.43,10.7c0,.2,0,.4,0,.59,0,1.06-.07,2.09-.16,3.12,0,.33.06.67.08,1,0,.49.06,1,.07,1.47A1.08,1.08,0,0,1,88.31,230.15Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.36,261.21v13h-6.8v-13a3.4,3.4,0,0,1,6.8,0Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.73,261.21v13h-6.8v-13a3.4,3.4,0,0,1,6.8,0Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,261.21V273A46.23,46.23,0,0,1,46.88,274V261.21a3.41,3.41,0,0,1,6.81,0Z",
    style: {
      fill: "#ffce4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "8b20e5ad-b0e4-47ab-ae26-3fe49e09465d",
    "data-name": "T-SHIRT",
    d: "M173,161.48a16.1,16.1,0,0,1-2.56,8.73l0,0a22.7,22.7,0,0,1-3,3.43.81.81,0,0,1-.1.09,23.38,23.38,0,0,1-10,5.48L165,224.39H76.08l7.61-45.16A23.34,23.34,0,0,1,74,174l-.06-.06a21.61,21.61,0,0,1-3.53-4.05l0,0A16,16,0,0,1,68,161.58a26.35,26.35,0,0,1,.82-5.2v0a28.62,28.62,0,0,1,22.93-20.57,23.79,23.79,0,0,1,9,2.51h0c.38.2.76.4,1.13.61l.43.07c1.44.14,2.91.25,4.42.35q2.88.19,5.92.3l3.1.08c1.15.1,2.31.18,3.49.23h.07l1.16-.06,1.16.06h.08c1.18,0,2.34-.13,3.49-.23l3.1-.08q3-.1,5.92-.3c1.5-.1,3-.21,4.42-.35l.43-.07c.37-.21.75-.41,1.13-.61h0a23.74,23.74,0,0,1,9-2.51,28.61,28.61,0,0,1,23,21,26,26,0,0,1,.69,4.35Z",
    style: {
      fill: "#ee4123"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "99f98273-8291-49d3-ae83-794951634f67",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "28092962-57d7-4076-94b6-39f5816e16bc",
    "data-name": "HEAD",
    d: "M190.36,108.23c-6.79,11.46-21.7,22.07-40.68,27.74-.92.27-1.84.54-2.78.79A97,97,0,0,1,136.29,139c-1,.09-2,.18-3,.25-3.32.25-6.8.41-10.46.48-1.15.1-2.31.18-3.49.23h-.08c-1.18,0-2.34-.13-3.49-.23-3.13-.06-6.13-.19-9-.38-1.5-.1-3-.22-4.42-.35a98,98,0,0,1-10.61-2.23l-.82-.23C71,131,55.3,120.08,48.29,108.23c-3.22-5.45-4.61-11.09-3.72-16.49.11-.63.24-1.25.41-1.87a20.13,20.13,0,0,1,1.28-3.45A21,21,0,0,0,47.62,84a19.36,19.36,0,0,0,1.29-3.45A19.6,19.6,0,0,0,49.57,75c0-.47,0-1-.08-1.42,0-.83-.06-1.67-.08-2.52a94.47,94.47,0,0,1,2.9-25.89,67.12,67.12,0,0,1,26-30.06,71.8,71.8,0,0,1,24.08-9.23c2.22-.44,4.49-.78,6.8-1q3-.33,6.19-.47c1.29-.06,2.6-.09,3.91-.1,1,0,1.93,0,2.89.05,2,.07,3.88.19,5.77.37q3.46.33,6.8.92a72.14,72.14,0,0,1,25.52,9.5,67.12,67.12,0,0,1,26,30.06,94.47,94.47,0,0,1,2.9,25.89c0,.85,0,1.69-.08,2.52-.05.47-.07.95-.08,1.42a20,20,0,0,0,.66,5.54A21,21,0,0,0,191,84a22.6,22.6,0,0,0,1.36,2.39,20.13,20.13,0,0,1,1.28,3.45c.17.62.3,1.24.41,1.87C195,97.14,193.58,102.78,190.36,108.23Z",
    style: {
      fill: "url(#5871ba50-ebd7-494a-b0a8-8e0ee3e0bd24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f7bad054-0804-4f28-bb04-0cd5f0bcfd86",
    "data-name": "SHADOW",
    d: "M190.35,108.24c-7.11,12-23.16,23.08-43.45,28.52A97,97,0,0,1,136.29,139q-6.28.58-13.44.73c-1.15.1-2.31.18-3.49.24h-.08c-1.18-.06-2.34-.14-3.49-.24q-7.16-.14-13.44-.73a97,97,0,0,1-10.61-2.23c-20.29-5.44-36.34-16.51-43.45-28.52-2.93-4.94-4.34-10-3.9-15,0,.32,0,.63.1.94a27.58,27.58,0,0,0,3.8,10.54c7.11,12,23.16,23.09,43.45,28.52a99.44,99.44,0,0,0,10.61,2.24c4.19.38,8.67.63,13.44.72,1.15.1,2.31.18,3.49.24h.08c1.18-.06,2.34-.14,3.49-.24,4.77-.09,9.25-.34,13.44-.72a99.44,99.44,0,0,0,10.61-2.24c20.29-5.43,36.34-16.51,43.45-28.52a27.6,27.6,0,0,0,3.81-10.54c0-.31.07-.62.1-.94C194.69,98.19,193.28,103.3,190.35,108.24Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "d60c23d9-a3c5-477e-8530-2ea58b5a7a06",
    "data-name": "EARS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.36,10.69c-2.39,1.47-4.8,3.05-7.19,4.73l-.67.47a95.51,95.51,0,0,0-9.62,7.8c-1.65,1.52-3.22,3.09-4.7,4.69a74.86,74.86,0,0,0-14,21.24,46.23,46.23,0,0,1-1.4-6.44A52.47,52.47,0,0,1,59.4,5.45l.6-.83c.7-.94,1.43-1.87,2.2-2.77l.23-.17A7,7,0,0,1,66.28.4s0,0,0,0c1.24.26,2.47.58,3.69.94A47.65,47.65,0,0,1,83.12,7.48l.06,0A45.47,45.47,0,0,1,87.36,10.69Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.88,23.69c-1.65,1.52-3.22,3.09-4.7,4.69a74.86,74.86,0,0,0-14,21.24,46.23,46.23,0,0,1-1.4-6.44A52.47,52.47,0,0,1,59.4,5.45C65,8.85,69,15.63,69.88,23.69Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74,10.29c2.39,1.47,4.79,3.05,7.18,4.73a92.7,92.7,0,0,1,15,13,74.76,74.76,0,0,1,14,21.24c4.37-14.94,1-31.66-8.85-45-.7-.93-1.43-1.86-2.2-2.77l-.22-.16A7,7,0,0,0,171.81,0h0c-1.24.26-2.47.57-3.69.94A47,47,0,0,0,155,7.09a.15.15,0,0,0-.07,0A44,44,0,0,0,150.74,10.29Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,23.69c1.65,1.52,3.22,3.09,4.71,4.69a75.07,75.07,0,0,1,14,21.24,47.72,47.72,0,0,0,1.4-6.44A52.52,52.52,0,0,0,178.7,5.45C173.12,8.85,169.07,15.63,168.21,23.69Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "9661b43e-188c-4079-b0c5-c581297f214d",
    "data-name": "EYEBROW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.15,36.08c.28,2-2.71,5.67-7.22,8.83-4.26,3-8.52,4.51-10.44,3.89a1.44,1.44,0,0,1-.81-.55c-1.18-1.68,2-5.9,7-9.42s10.07-5,11.25-3.35A1.3,1.3,0,0,1,88.15,36.08Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,36.08c-.29,2,2.7,5.67,7.21,8.83,4.26,3,8.52,4.51,10.45,3.89a1.42,1.42,0,0,0,.8-.55c1.18-1.68-2-5.9-7-9.42s-10.07-5-11.25-3.35A1.28,1.28,0,0,0,148.87,36.08Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "f9aaf35d-80f5-491d-af7f-9d1bcfd382f9",
    "data-name": "MUSTACHE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.57,108.8c-.14,1.7-6.52,2.53-14.23,1.86s-13.84-2.6-13.69-4.3,6.52-2.54,14.23-1.86S69.72,107.1,69.57,108.8Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.19,118.11c.15,1.7-6,3.62-13.69,4.3s-14.09-.16-14.24-1.86,6-3.63,13.7-4.3S70,116.4,70.19,118.11Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.26,106c.12,1.44,5.54,2.15,12.1,1.58s11.76-2.21,11.64-3.66-5.55-2.15-12.1-1.58S173.13,104.51,173.26,106Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.26,113.34c-.13,1.45,5.08,3.08,11.64,3.66s12-.14,12.1-1.58-5.09-3.09-11.64-3.66S173.38,111.9,173.26,113.34Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,4.88v11a3.4,3.4,0,0,1-6.8,0v-10Q105.75,5.28,109.22,4.88Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,4.37V17.75a3.4,3.4,0,1,1-6.8,0V4.4c1.29-.05,2.59-.08,3.91-.09C120.29,4.32,121.25,4.33,122.21,4.37Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.78,5.65V15.89a3.4,3.4,0,0,1-6.8,0V4.73Q131.45,5.06,134.78,5.65Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "e9fe33f0-4d84-4d2c-958a-482d4dbdd9ed",
    "data-name": "EYES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106,79.29a21.78,21.78,0,0,1-36.42,16,4.65,4.65,0,0,1-4,2.3,4.8,4.8,0,0,1-4.7-4.9,4.87,4.87,0,0,1,3.41-4.71,21.31,21.31,0,0,1-1.82-8.65,21.76,21.76,0,0,1,43.51,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,76.71A17.64,17.64,0,1,1,85.27,59.22,17.56,17.56,0,0,1,102.9,76.71Z",
    style: {
      fill: "url(#59d95db4-cc2a-4e3d-824e-95c26e51ef9b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.27,95.24a18.53,18.53,0,1,1,18.66-18.53A18.62,18.62,0,0,1,85.27,95.24Zm0-35a16.47,16.47,0,1,0,16.6,16.46A16.56,16.56,0,0,0,85.27,60.25Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,76.8A11.72,11.72,0,1,1,88,65.09,11.72,11.72,0,0,1,99.7,76.8Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.78,80.07A1.78,1.78,0,1,1,74,78.3,1.77,1.77,0,0,1,75.78,80.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,73.12A3.76,3.76,0,1,0,79,69.2,3.83,3.83,0,0,0,75.29,73.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.08,92.65a4.8,4.8,0,0,1-4.7,4.9,4.67,4.67,0,0,1-3.89-2.15,21.32,21.32,0,1,1,7.11-15.86A21.17,21.17,0,0,1,174.84,88,4.87,4.87,0,0,1,178.08,92.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19,77.23a17.64,17.64,0,1,1-17.64-17.49A17.58,17.58,0,0,1,171.19,77.23Z",
    style: {
      fill: "url(#17b4ace5-a28d-431f-a734-1518dcffba1d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55,95.76a18.53,18.53,0,1,1,18.67-18.53A18.62,18.62,0,0,1,153.55,95.76Zm0-35a16.47,16.47,0,1,0,16.61,16.46A16.55,16.55,0,0,0,153.55,60.77Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,77.58a11.72,11.72,0,1,1-11.72-11.72A11.72,11.72,0,0,1,162.06,77.58Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49,80.07a1.78,1.78,0,1,1-1.78-1.77A1.78,1.78,0,0,1,167.49,80.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,73.12a3.76,3.76,0,1,0,3.76-3.92A3.84,3.84,0,0,0,156.8,73.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ec4fbd6b-702f-46f6-8a71-72c20b84b29f",
    "data-name": "MOUTH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.9,104.29a14.45,14.45,0,0,1-5.75,11.61,13.58,13.58,0,0,1-16.33,0,14.45,14.45,0,0,1-5.75-11.61,13.53,13.53,0,0,1,.12-1.81,14.73,14.73,0,0,0,2.9,1.92c.52.26,1,.49,1.59.7a19,19,0,0,0,2.29.71c.53.13,1.06.23,1.6.32a36,36,0,0,0,10.84,0c.54-.09,1.07-.19,1.6-.32a17.87,17.87,0,0,0,2.29-.71c.54-.21,1.06-.44,1.58-.7a14.8,14.8,0,0,0,2.91-1.92A13.54,13.54,0,0,1,133.9,104.29Z",
    style: {
      fill: "url(#be12dd70-9271-49cb-9b79-685037bbbb70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9,104.29c0,.39,0,.78,0,1.16,0-.22,0-.44-.07-.66a15.48,15.48,0,0,1-4.49,2.63,19.36,19.36,0,0,1-3.89,1,36,36,0,0,1-10.84,0,19.87,19.87,0,0,1-3.89-1,15.22,15.22,0,0,1-4.49-2.63c0,.23-.06.45-.07.68,0-.39-.05-.78-.05-1.18a13.53,13.53,0,0,1,.12-1.81,15.19,15.19,0,0,0,4.49,2.62,19.87,19.87,0,0,0,3.89,1,36,36,0,0,0,10.84,0,19.36,19.36,0,0,0,3.89-1,15.45,15.45,0,0,0,4.49-2.62A13.54,13.54,0,0,1,133.9,104.29Z",
    style: {
      fill: "#d5635e",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,105.81c-.21,1.7-1,3.29-1.92,3.29s-2-1.66-2-3.7c0-.15,0-.59,0-1,.52.26,1,.49,1.59.7A19,19,0,0,0,113,105.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9,105.4c0,2-.89,3.7-2,3.7-.92,0-1.7-1.59-1.91-3.29a17.87,17.87,0,0,0,2.29-.71c.54-.21,1.06-.44,1.58-.7C130.89,104.81,130.9,105.25,130.9,105.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,115.9a13.58,13.58,0,0,1-16.33,0,16.45,16.45,0,0,1,16.33,0Z",
    style: {
      fill: "#c44756"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "afeda1cd-0b64-4956-b7e3-7358b8f4b566",
    "data-name": "NOSE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.74,91.51c0,2.16-3.32,3.92-7.42,3.92s-7.42-1.76-7.42-3.92,3.32-3.92,7.42-3.92S126.74,89.35,126.74,91.51Z",
    style: {
      fill: "url(#2f5b5800-3500-4f7a-831a-e1513659146e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.86,89.86c0,.69-.88,1.24-2,1.24s-2-.55-2-1.24.88-1.23,2-1.23S123.86,89.18,123.86,89.86Z",
    style: {
      fill: "#facac2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "d26afe5b-9c1c-4d37-8b34-4063b94e34f3",
    "data-name": "SHADOWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.23,143.85l-3.31.17c-1.53.06-3.09.1-4.68.14-1.15.1-2.31.18-3.49.23h-.08c-1.18,0-2.34-.13-3.49-.23q-3.83-.07-7.39-.28c-1.1-.06-2.17-.13-3.23-.21,0-.06,0-.12.08-.19.2-.46.41-.94.6-1.41s.45-1.07.66-1.61c0,0,0,0,0,0,.13-.32.25-.63.37-.94l3.13.14c1.11,0,2.23.07,3.38.09s2.31.18,3.49.23h.07c1.19,0,2.35-.13,3.5-.23q2.79-.06,5.46-.18l3.07-.17c.13.36.27.71.41,1.06l0,0c.19.48.38,1,.58,1.45l.18.43c.2.48.41,1,.62,1.44A.2.2,0,0,1,133.23,143.85Z",
    style: {
      fill: "#c42128",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52,168.2a9.21,9.21,0,0,1-.49,1.39,12,12,0,0,1-2.52,3.68A11.82,11.82,0,0,1,150.89,175c-.53-.51-1-1-1.57-1.56q-1.17-1.19-2.28-2.4l-.42-.47a90,90,0,0,1-7.07-8.84,86.58,86.58,0,0,1-5.27-8.46q-1.41-2.58-2.62-5.2c-.62-1.34-1.2-2.69-1.74-4l3.31-.17.46,1q1.22,2.61,2.62,5.2a89.8,89.8,0,0,0,5.27,8.46q2.38,3.41,5.13,6.63c.63.74,1.28,1.48,1.94,2.21l.43.47c.2.21.39.43.6.64.55.6,1.11,1.18,1.68,1.76l.27.28h0a11.66,11.66,0,0,0,15.15-.38,11,11,0,0,0,1.07-1.09A10.77,10.77,0,0,0,168.52,168.2Z",
    style: {
      fill: "#c42128",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,143.85l-3.31.17-.15-.37s0,0,0,0c-.3-.73-.58-1.47-.85-2.21-.15-.42-.3-.85-.44-1.27l0,0c0-.16-.07-.31-.12-.47a.36.36,0,0,0,0-.1c-.07-.3-.13-.6-.2-.89,0,0,0,0,0,0a16.69,16.69,0,0,1,.73-9.48,9.46,9.46,0,0,1,2-3,16.88,16.88,0,0,0-.67,9.31v0c.07.33.14.66.22,1l.06.23a1.55,1.55,0,0,0,.06.23s0,0,0,0l.45,1.27c.14.38.28.77.43,1.15s.27.71.41,1.06l0,0c.19.49.38,1,.58,1.45l.18.43c.2.48.41,1,.62,1.44A.2.2,0,0,1,133.23,143.85Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#6d757a5f-8622-448c-89b5-b1781f93c869)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.79,143.88c-.47,1.15-1,2.28-1.49,3.41-.8,1.75-1.68,3.48-2.62,5.2a89,89,0,0,1-5.27,8.46,91.43,91.43,0,0,1-7.06,8.84l-.43.47q-1.11,1.22-2.28,2.4c-.52.52-1,1.05-1.57,1.56a11.77,11.77,0,0,1-10.18,1.09A11.61,11.61,0,0,1,77.28,174l-.28-.19a8.35,8.35,0,0,1-.88-.69,7.81,7.81,0,0,1-.67-.62,11.54,11.54,0,0,1-1.61-2,11.69,11.69,0,0,0,15.4-.17l.11-.11,1-1c.45-.47.9-.94,1.33-1.41l.43-.47a94.38,94.38,0,0,0,7.07-8.84,89.69,89.69,0,0,0,5.26-8.46c.94-1.72,1.82-3.46,2.62-5.2.19-.4.37-.8.55-1.2C108.62,143.75,109.69,143.82,110.79,143.88Z",
    style: {
      fill: "#c42128",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91,137.47v.11c0,.09,0,.17-.05.26v0c-.07.33-.14.66-.22,1l-.12.47,0,0c0,.08,0,.17-.08.26-.12.34-.23.67-.36,1-.27.74-.55,1.47-.84,2.21l0,0-.4,1c-1.1-.06-2.17-.13-3.23-.21,0-.06,0-.12.08-.19.2-.46.41-.94.6-1.41s.45-1.07.66-1.61c0,0,0,0,0,0,.13-.32.25-.63.37-.94l.48-1.27c.11-.29.21-.58.31-.87,0-.14.09-.27.13-.4l0,0c0-.15.07-.31.12-.46.08-.34.15-.67.22-1,0,0,0,0,0,0a16.77,16.77,0,0,0-.74-9.48,10.38,10.38,0,0,0-.79-1.52,7,7,0,0,1,1,.76,9.38,9.38,0,0,1,2.12,3.18A16.47,16.47,0,0,1,112.91,137.47Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#4380546f-d9f9-4b66-ac9d-fc695fd1d7c3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,228.5a32,32,0,0,0,5.8,12.76c-.24,1-.54,2-.86,2.94q-.18.56-.39,1.11c-.06.18-.14.37-.2.55s-.13.32-.19.47-.18.46-.28.68-.14.32-.21.48-.2.47-.3.69c-.16.37-.33.72-.5,1.06-.34.69-.69,1.37-1.07,2-4.18-5.25-6.91-13.91-6.91-23.7,0-1.07,0-2.13.1-3.18h3.81v0h81.19c-.13,1.4-.3,2.77-.51,4.13Z",
    style: {
      fill: "#f1b02e",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "5aa94533-54e6-4eb6-89e9-7462c9f32f48",
    "data-name": "PAWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.6,161.67a11.2,11.2,0,0,1-2.07,6.53c-.2.3-.43.58-.66.86a10.91,10.91,0,0,1-1.06,1.09,11.68,11.68,0,0,1-15.16.38h0l-.27-.28c-.57-.58-1.13-1.16-1.67-1.76-.22-.21-.41-.43-.61-.64l-.43-.47c-.66-.73-1.3-1.47-1.93-2.21q-2.75-3.22-5.14-6.63a87.68,87.68,0,0,1-5.26-8.46c-.95-1.73-1.82-3.46-2.63-5.2l-.46-1c-.5-1.13-1-2.26-1.42-3.4l0,0c-.14-.35-.28-.7-.41-1.06l-.43-1.15-.45-1.28v0l-.06-.23-.06-.23c-.08-.34-.15-.68-.22-1v0a16.88,16.88,0,0,1,.67-9.31.87.87,0,0,1,.07-.17,7.88,7.88,0,0,1,4.72-4.73l.26-.08a7.83,7.83,0,0,1,6.81,1.76,14.06,14.06,0,0,1,2.9,3.08,19.4,19.4,0,0,1,2.84,6.14,1.36,1.36,0,0,0,0,.17l.14.25a61.7,61.7,0,0,0,10.71,14.31c1.41,1.41,2.86,2.74,4.36,4,.39.33.79.65,1.19,1,.74.59,1.5,1.15,2.25,1.69A11.35,11.35,0,0,1,170.6,161.67Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,135.42s0,0,0,0c-.07.33-.14.66-.22,1l-.12.46s0,0,0,0-.08.27-.13.41c-.1.29-.2.58-.31.87s-.31.84-.47,1.27-.25.62-.37.94l0,0c-.42,1.08-.87,2.14-1.34,3.21-.18.4-.36.8-.55,1.2-.8,1.74-1.68,3.48-2.61,5.2a91.92,91.92,0,0,1-5.27,8.46,94.38,94.38,0,0,1-7.07,8.84l-.43.47c-.43.47-.88.94-1.32,1.41l-1,1-.11.11a11.68,11.68,0,0,1-15.39.17,11.36,11.36,0,0,1-.46-16.89l0,0c.75-.53,1.49-1.08,2.21-1.65.48-.37.94-.75,1.41-1.13,1.49-1.23,2.94-2.56,4.35-4a61.35,61.35,0,0,0,9.94-12.93c.26-.46.52-.92.77-1.38l.14-.25a.85.85,0,0,1,0-.17A19.61,19.61,0,0,1,95.12,126,14.59,14.59,0,0,1,98,122.89a7.82,7.82,0,0,1,6.81-1.75l.26.07a6.74,6.74,0,0,1,3.17,2.16,8.3,8.3,0,0,1,.76,1,10.38,10.38,0,0,1,.79,1.52A16.77,16.77,0,0,1,110.56,135.42Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,268.3l0,0h.16c4.17.74,7.15,2.67,7.15,4.95,0,2.91-4.84,5.26-10.82,5.26-5.28,0-9.68-1.84-10.62-4.27l-.09-.24s0,0,0-.06a6.55,6.55,0,0,1-.1-.79v-.47a6,6,0,0,1,.39-1.87l0-.05a48.47,48.47,0,0,0,1.75-5.71c.27-1.09.5-2.2.7-3.33.52-3,1.88-10.66,2.73-17.21a42.55,42.55,0,0,1-8.47.86c-.13,0-.25,0-.38,0a40.9,40.9,0,0,1-4.15-.24,51.59,51.59,0,0,0,2.54,10c.39,1.07.82,2.12,1.27,3.15a50.16,50.16,0,0,0,2.72,5.32s0,0,0,.05a5.82,5.82,0,0,1,.71,1.77,1.74,1.74,0,0,0,0,.22l0,.24a7.31,7.31,0,0,1,0,.8.13.13,0,0,1,0,.06,2.17,2.17,0,0,1,0,.25c-.51,2.56-4.52,5.13-9.72,6.05-4.94.87-9.38,0-11-2a2.79,2.79,0,0,1-.59-1.27c-.34-1.89,1.47-3.92,4.43-5.37a15.77,15.77,0,0,1,1.76-.74l.15,0s0,0,0,0c-.82-.44-1.63-.9-2.43-1.4a56.59,56.59,0,0,1-16.82-16.54,71.42,71.42,0,0,1-7.59-14.6c-.32-.84-.63-1.7-.93-2.55-.16-.47-.31-.93-.46-1.39-.29-.9-.57-1.8-.82-2.72h81.13c-.13,1.39-.3,2.76-.5,4.11C158.15,245.63,149.51,259.68,138.57,268.3Z",
    style: {
      fill: "#f1b02e"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappyCat);
export default __webpack_public_path__ + "static/media/IconHappyCat.5942e915.svg";
export { ForwardRef as ReactComponent };